export const RESERVED_SHOP_SLUGS = new Set([
  'platform',
  'www',
  'api',
  'uploads',
  'docs',
  'admin',
  'cont',
  'checkout',
  'produse',
  'categorii',
  'branduri',
  'cos',
  'cautare',
  'contact',
  'compara',
  'tracking',
  'vinde',
  'retur',
  'generator',
  'cms',
  'start',
  'preturi',
  'termeni',
  'confidentialitate',
  '_nuxt',
  'favicon.ico',
  'robots.txt',
  'sitemap.xml',
])
